const CARD_TYPES = {
    VISA: 'visa',
    AMEX: 'amex',
    MASTERCARD: 'mastercard',
    DISCOVER: 'discover',
    MAESTRO: 'maestro',
    TROY: 'troy'
}

export {
    CARD_TYPES
}
